import { Checkbox as CheckboxMantine } from '@mantine/core'
import styled from 'styled-components'

export const Checkbox = styled(CheckboxMantine)`
  .mantine-Checkbox-input {
    background-color: transparent !important;
    border: 2px solid ${({ theme }) => theme.cor39} !important;
    border-radius: 4px;

    :disabled {
      background-color: ${({ theme }) => theme.cor72} !important;
      border-color: ${({ theme }) => theme.cor73} !important;
    }

    :checked {
      background-color: ${({ theme }) => theme.cor11} !important;
      border-color: ${({ theme }) => theme.cor11} !important;
    }
  }

  .mantine-Checkbox-label {
    color: ${({ theme }) => theme.cor9} !important;
    font-size: 16px !important;
    background-color: transparent !important;
    font-weight: 500;
    font-family: Roboto;
  }

  .mantine-Checkbox-label[data-disabled] {
    color: ${({ theme }) => theme.cor75} !important;
  }
`
